import { useEffect, useState } from "react";
import { Booking, getEndDateForWeek, getStartDateForWeek, getWeekNumber, hasOverlap, removeBooking, setNewBooking } from "./calendarController";
import { Details, Form } from "./Styled";


interface DetailCardProps {
    booking?: Booking;
    date?: Date | null;
    setBooking?: any;
    setEdit?: any;
}

export const DetailCard: React.FC<DetailCardProps> = ({booking, setEdit})=>{

    if( !booking ){
        return null;
    }

    return (
    <Details>
        <div className="header">
            <h2>{booking.week}. viikko</h2>
            <p>
                {`${booking.startDate.toLocaleDateString("fi-FI")} - ${booking.endDate.toLocaleDateString("fi-FI")}`}
            </p>
        </div>
        <div className="content">
            <h2>{booking.title}</h2>
            {booking.description && <p className="description">{booking.description}</p>}
        </div>
        {false && <div>
            <button onClick={()=>{setEdit( booking )}}>Muokkaa</button>
            <button onClick={() => removeBooking( booking! )}>Poista</button>
        </div>}

    </Details>
    );

};

export const DetailCardEdit: React.FC<DetailCardProps>  = ( {date, setBooking, booking}) => {
    const day = date ? new Date(date) : booking ? new Date(booking.startDate) : new Date();

    const [formData, setFormData] = useState({
        week: `${date? getWeekNumber(date): booking? booking.week : ""}`,
        fullWeek: false,
        startDate: day.toISOString().split('T')[0] ?? "",
        endDate: booking?.endDate?.toISOString().split("T")[0] ?? "",
        title: booking?.title ?? "",
        description: booking?.description ?? ""
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleChangeCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = e.target;
        setFormData({ ...formData, [name]: checked });
    };

    useEffect(() => {
        if (formData.fullWeek && formData.week) {
            const prevSaturday = getStartDateForWeek(parseInt(formData.week));
            const nextSaturday = getEndDateForWeek(parseInt(formData.week));

            setFormData({
                ...formData,
                startDate: prevSaturday.toISOString().split("T")[0],
                endDate: nextSaturday.toISOString().split("T")[0],
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData.fullWeek, formData.week]);

    const [overlap, setOverlap] = useState<string|null>(null);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const booking = new Booking(
            new Date(formData.startDate),
            new Date(formData.endDate),
            formData.title,
            formData.description
        );
        const notOk = hasOverlap(booking);
        console.log(notOk);

        if( !notOk ){

            try{
                setNewBooking( booking, true );
                setBooking( booking );
                setFormData({ week: '', fullWeek: false, startDate: '', endDate: '', title: '', description: '' });
            } catch( error : any ) {
                    setOverlap( error.message );
            }
        } else {
            const error = "Varaus menee päällekäin toisen varauksen kanssa:" + notOk.title;
            setOverlap( error );
        }
    };

    return (
        <Details>
            <Form onSubmit={handleSubmit}>
                <h2>Uusi varaus</h2>

                <label>Viikko:</label>
                <input
                    type="number"
                    name="week"
                    value={formData.week}
                    onChange={handleChange}
                />

                <div className="weekDetails">
                    <input
                        type="checkbox"
                        name="fullWeek"
                        checked={formData.fullWeek}
                        onChange={handleChangeCheckbox}
                        id="fullWeek"
                    />
                    <label htmlFor="fullWeek">Koko viikon varaus</label>
                </div>

                <label>Alkaa:</label>
                <input
                    type="date"
                    name="startDate"
                    value={formData.startDate}
                    onChange={handleChange}
                    required
                />

                <label>Päättyy:</label>
                <input
                    type="date"
                    name="endDate"
                    value={formData.endDate}
                    onChange={handleChange}
                    required
                />

                <label>Otsikko:</label>
                <input
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    required
                />

                <label>Lisätiedot:</label>
                <textarea
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    rows={3}
                />

                {overlap && (
                <p style={{ color: "red" }}>
                    {overlap}
                </p>
                )}
                <button disabled={Boolean(overlap)} type="submit">Tallenna</button>
            </Form>
        </Details>
    );
}
